import React, { Component } from "react";

class Loading extends Component {
  render() {
    return <div className="card">Chargement...</div>;
  }
}

export default Loading;
